<template>
  <div>
    <el-container direction="vertical">
      <el-row>
        <el-table v-loading="listLoading" :data="manageList" border fit highlight-current-row style="width: 100%">
          <el-table-column width="100px" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>
          <el-table-column width="115px" align="center" label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.phone || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" align="center" label="检查时间">
            <template slot-scope="scope">
              <span>{{ getParsedTime(scope.row.examReportInfo?.reportTime) || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="180px" align="center" label="项目">
            <template slot-scope="scope">
              <span>{{ scope.row.examReportInfo?.examItems?.[0]?.itemName || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column width="120px" align="center" label="登记号">
            <template slot-scope="scope">
              <span>{{ scope.row.recordNo || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column width="115px" align="center" label="报告编号">
            <template slot-scope="scope">
              <span>{{ scope.row.examReportInfo?.reportCode || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="360" align="center" label="描述">
            <template slot-scope="scope">
              <span>{{ scope.row.examReportInfo?.examItems?.[0]?.examObserved || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="300" align="center" label="结论">
            <template slot-scope="scope">
              <span>{{ scope.row.examReportInfo?.examItems?.[0]?.examResult || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="协诊时间">
            <template slot-scope="scope">
              <span>{{ getParsedTime(scope.row.codiagTime) || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="handleView(scope.row, scope.$index)">协诊详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />

        <codiagnosisModal v-if="codiagDiagVisible" ref="codiagDiagRef">
        </codiagnosisModal>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import {
  turnToMyListCodiag,
  getlistCodiags,
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import imageLine from "@/assets/images/titleLine.png";
import moment from "moment";
import codiagnosisModal from "../../components/codiagnosisModal/index.vue";

export default {
  components: { Pagination, codiagnosisModal },
  props: {
    pInfo: null
  },
  data() {
    return {
      open: false,
      linkLine: imageLine,
      valueData: null,
      codiagDiagVisible: false,
      listLoading: false,
      total: 0,
      listQuery: {
        idcard: null,
        patientName: null,
        noVisitHoursStart: null,
        noVisitHoursEnd: null,
        codiagHospital: null,
        codiagStatus: null,
        codiagStartTime: null,
        codiagEndTime: null,
        codiagDealResult: null,
        phone: null,
        pageNum: 1,
        pageSize: 10,
        taskStatus: "协诊"
      },
      manageList: []
    };
  },
  watch: {},
  created() { this.getList(this.pInfo); },
  methods: {
    setOpen(bool) {
      this.open = bool;
    },
    async getList(row = {}) {
      this.listLoading = true;
      try {
        this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
        this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;
        const res = await getlistCodiags({ ...this.listQuery, idcard: row.idcard })
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
        this.listLoading = false;
      } catch (e) {
        this.listLoading = false;
        console.warn('e: ', e)
      }
    },
    turnToPage() {
      this.listLoading = true;

      this.listQuery.codiagStartTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.codiagEndTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      turnToMyListCodiag({ ...this.listQuery, idcard: row.idcard }).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    handleView(row, index) {
      this.codiagDiagVisible = true;
      row['isRead'] = true;
      this.$nextTick(() => {
        this.$refs['codiagDiagRef'].init(row);
      })
    },
    getParsedTime(time) {
      if (!time) return null;
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table thead th {
  background-color: #f5f5f5 !important;
}
</style>
